const seperator = '__'

export default {
  computed: {
    mixinPageId() {
      const { query } = this.$route
      const components = query?.pageKey?.split(seperator) ?? null
      if (components == null || components.length < 2) {
        return null
      }
      return components[1]
    },
    mixinAppId() {
      const { query } = this.$route
      const components = query?.pageKey?.split(seperator) ?? null
      if (components == null || components.length < 1) {
        return null
      }
      return components[0]
    },
    mixinToken() {
      const { query } = this.$route
      return query?.token ?? null
    },
  },
  methods: {
    buildPageKey(appId, pageId) {
      if (!appId) {
        return null
      }
      if (!pageId) {
        return appId
      }
      return `${appId}${seperator}${pageId}`
    }
  },
}